export default {"src":"__ASTRO_ASSET_IMAGE__h7oohK2n__","width":80,"height":32,"format":"svg"}